import { combineReducers } from 'redux';

import dashboard from './dashboard';
import details from './details';
import duplicate from './duplicate';

export default combineReducers({
  details,
  dashboard,
  duplicate,
});
